import type { FC, PropsWithChildren } from 'react';

import type TranslationKey from '@/lib/i18n/TranslationKey.ts';
import useTitle from '@/lib/useTitle.ts';

import Footer from '../Footer.tsx';
import Header from '../Header/index.tsx';
import RegisteredWrapper from '../RegisteredWrapper.tsx';

type AuctionLayoutProps = {
  title: TranslationKey;
};

const AuctionLayout: FC<PropsWithChildren<AuctionLayoutProps>> = ({ title, children }) => {
  useTitle(title);

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />

      <div className="position-relative d-flex flex-column flex-grow-1 pb-5">
        <RegisteredWrapper>{children}</RegisteredWrapper>
      </div>

      <div className="flex-grow-0">
        <Footer />
      </div>
    </div>
  );
};

export default AuctionLayout;
